export default function (state, payload) {
  const { campaigns } = payload;
  state = {...state, campaigns}
  return { ...state};
}
